var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropzone",staticClass:"dropzone"})
}
var staticRenderFns = []

export { render, staticRenderFns }